// Where 「← asaptodo」 on a tool page goes: the last page with the app's
// header (or an artifact page) this tab was on, so a tool opened from
// /wiki returns to /wiki instead of always landing on 今天. Per tab
// (sessionStorage); a fresh tab, or storage that throws, falls back.
const KEY = 'asaptodo:last-page';
const FALLBACK = '/todo/today';

export function rememberPage(url: string) {
  try {
    window.sessionStorage.setItem(KEY, url);
  } catch {
    // Private mode or blocked storage: the fallback still works.
  }
}

export function lastPage(): string {
  try {
    const url = window.sessionStorage.getItem(KEY);
    // Only same-app paths; never bounce to another tool page.
    if (url && url.startsWith('/') && !url.startsWith('//') && !url.startsWith('/t/')) return url;
  } catch {
    // Same as above.
  }
  return FALLBACK;
}
